package com.nonopn.skydome.common.app.checkout

// Access to the launch URL for the return from the Stripe Checkout. Only the web app has a query string:
// the other platforms return "" and do nothing.

/** Query string of the current URL, with its leading '?', or "". */
expect fun checkoutCurrentQuery(): String

/** Replaces the query string of the address bar without reloading the page (history.replaceState). */
expect fun checkoutReplaceQuery(query: String)

/** Codes already sent to POST /api/checkout/login from this tab (kept across a reload on the web). */
expect fun checkoutAttemptStore(): CheckoutAttemptStore

/** Removes checkout, product, session_id and code from the address bar, keeping any other parameter. */
fun clearCheckoutParams() {
    val query = checkoutCurrentQuery()
    val cleaned = queryWithoutCheckoutParams(query)
    if (cleaned != query) checkoutReplaceQuery(cleaned)
}
